import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ToastMessageService } from '../../../widgets/toast-message/toast-message.service';
import { ApiService } from '../../../services/api.service';
import { FormService } from 'src/app/services/form.service';
import { AuthService } from 'src/app/services/auth.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-department-form',
  templateUrl: './edit-department-form.component.html',
  styleUrls: ['./edit-department-form.component.scss']
})
export class EditDepartmentFormComponent implements OnInit, OnChanges {

  @Input() id: number;
  @Input() department: any;

  @Output() formSaved: EventEmitter<any> = new EventEmitter<any>();

  // states
  isSubmitted = false;
  reveal = false;

  // claims
  canEdit = this._authSvc.hasClaim('Departments', 'Edit');

  // form group
  form: UntypedFormGroup = this._fb.group({
    Id: [null],
    DepartmentCode: [null, Validators.required],
    DeptDescription: [null, Validators.required],
    MarginValue: [0, Validators.required],
    StartDate: [this._utilsSvc.todaysDate],
    EndDate: [null],
    CstmLzbCategoryId: [null]
  });

  // error messages
  fieldErrors: any = {};
  formErrors: any = null;

  // la z boy categories
  lzbCategories = null;

  // form config
  formProcessing = false;

  // endpoints
  private _depEndpoint = `${this._apiSvc.endpoints.catalog}/api/Department`;
  private _lzbEndpoint = `${this._apiSvc.endpoints.catalog}/api/CustomLzbCategory`;

  constructor(
    private _apiSvc: ApiService,
    private _authSvc: AuthService,
    private _fb: UntypedFormBuilder,
    private _formSvc: FormService,
    private _router: Router,
    private _toastMsgSvc: ToastMessageService,
    private _utilsSvc: UtilitiesService
  ) {}

  ngOnInit() {
    this.getCategories();

    if (!this.canEdit) {
      this.form.disable();
    }

  }

  ngOnChanges() {

    if (this.department) {
      this._pacthForm(this.department);
    }
  }

  /**
   * Patch form values
   * @param values
   */
  private _pacthForm(values: any): void {
    const patchValue = this._formSvc.getPatchValue(this.form.controls, values);
    this.form.patchValue(patchValue);
  }

  /**
   * Process add department form
   * @param e
   */
  onSubmit(e: Event): void {

    e.preventDefault();

    this.isSubmitted = true;

    // if form is invalid, return
    if (!this.form['valid'] || this.formProcessing) {
      return;
    }

    // clear errors
    this.formErrors = null;
    this.fieldErrors = {};

    // set form to processing to prevent double submissions and show spinner
    this.formProcessing = true;

    const id = this.form.get('Id').value,
      action = id ? 'update' : 'add',
      path = id ? `${this._depEndpoint}/${id}` : this._depEndpoint;

    // add department via service
    this._apiSvc[action](path, this.form.value)
      .subscribe((res: any) => {

        this.formProcessing = false;

        // show success message
        this._toastMsgSvc.send({
          icon: 'check_circle_outline',
          message: 'Department saved',
          type: 'success'
        });

        // on success, redirect to edit
        if (action === 'add' && res && res['Id']) {
          this._router.navigate([`/merchandising/departments/${res['Id']}`]);
        } else {
          this.formSaved.emit(res);
        }

      }, (err) => {

        const errors = this._formSvc.processFormErrors(err);

        if (errors.formErrors) {
          this.formErrors = errors.formErrors;
        }

        if (errors.fieldErrors) {
          this.fieldErrors = errors.fieldErrors;
        }

        this.formProcessing = false;

      });

  }

  /**
   * Get data for the view
   */
  private getCategories(): void {

    this._apiSvc.get(this._lzbEndpoint)
      .subscribe((res: any) => {
        this.lzbCategories = res.Data;
        this.reveal = true;
      });

  }

}
